import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { PlaylistLessonCard } from '@lean-body/components/molecules/playlist_lesson_card';
import { MediaBreakPointUp } from '@lean-body/components/styles/variables';
export const PlaylistDetail = ({ lessons, lessonViewCounts, lessonFavoriteStatusArray, onClickLesson, onClickLessonFavoriteButton, className, }) => {
    const wrapperClass = [className || '', css(styles.wrapper)].join(' ');
    const getIsFavoriteByStatusArray = (lesson) => {
        const lessonFavoriteStatus = lessonFavoriteStatusArray.find((data) => data.id === lesson.id);
        return !!lessonFavoriteStatus && lessonFavoriteStatus.isFavorite;
    };
    return (React.createElement("div", { className: wrapperClass },
        React.createElement("div", { className: css(styles.cards) }, lessons.map((lesson, index) => {
            var _a;
            return (React.createElement(PlaylistLessonCard, { key: index, lesson: lesson, viewCount: (_a = lessonViewCounts.find((v) => v.lessonId === lesson.id)) === null || _a === void 0 ? void 0 : _a.view, isFavorite: getIsFavoriteByStatusArray(lesson), onClickPlayButton: onClickLesson, onClickLessonFavoriteButton: onClickLessonFavoriteButton, classObject: styles.card }));
        }))));
};
const styles = StyleSheet.create({
    wrapper: {
        display: 'flex',
    },
    card: {
        marginBottom: 12,
        ':last-child': {
            marginBottom: 0,
        },
        [MediaBreakPointUp.MD]: {
            marginBottom: 24,
        },
    },
    cards: {
        flex: 1,
    },
});
